//
// universal-image-actions-helpers.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*global angular: false*/

(function() {
    var curalate = angular.module('curalate');

    curalate.factory('UniversalItemId', function() {
        var UniversalItemId = function(itemType, itemId, clientId) {
            this.itemType = itemType;
            this.itemId = itemId;
            this.clientId = clientId;
        };

        UniversalItemId.prototype.toString = function() {
            var uidString = this.itemType + '.' + this.itemId;

            if (this.clientId) {
                uidString += ('.' + this.clientId);
            }

            return uidString;
        };

        return UniversalItemId;
    });

    // TODO: Refactor methods specific to the UIA modal into the main pinsights repository
    curalate.service('UniversalImageActionsHelpers', ['StringUtils', 'TrackingService', 'UniversalItemId',
        function(StringUtils, TrackingService, UniversalItemId) {
            this.getTrackingCategory = function(page) {
                if (angular.isUndefined(page)) {
                    page = 'other';
                }
                return StringUtils.formatString('%s.%s', TrackingService.CATEGORY_UNIVERSAL_IMAGE_ACTIONS, page);
            };

            this.parseUniversalItemId = function(universalItemId) {
                var parts = universalItemId.split('.');
                if (parts.length < 3) {
                    throw new Error("Invalid universal item ID passed to parse. UID = " + universalItemId);
                }

                return new UniversalItemId(parts[0], parts[1], parts[2]);
            };

            this.parsePartialUniversalItemId = function(partialUniversalItemId, clientId) {
                var uid, parts;
                if (clientId) {
                    uid = StringUtils.formatString("%s.%s", partialUniversalItemId, clientId);
                    return this.parseUniversalItemId(uid);
                } else {
                    parts = partialUniversalItemId.split('.');
                    return new UniversalItemId(parts[0], parts[1], parts.length === 3 ? parts[2] : null);
                }
            };

            this.getImageDimensions = function(img) {
                return {
                    naturalHeight: img.height,
                    naturalWidth: img.width
                };
            };

            this.itemIdToUniversalItemId = function(itemType, itemId, clientId) {
                return new UniversalItemId(itemType, itemId, clientId).toString()
            }
        }
    ]);
})();
